module.exports = __webpack_public_path__ + "img/57_15.ee99d254.png";